<div id="login-page" class="flex-container">
  <div class="flex-container">
    <div class="app-name">{{ TranslationKeys.GeneralAssistant | translate }}</div>
    <div class="separator"></div>

    <div>
      <button id="grant-permissions" nimbusPrimaryButton [disabled]="isRunning$ | async" (click)="login()">
        <img
          class="icon"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAzRJREFUeJztWktuFDEQfZUZlCgChbBmwRlyg0goYh2JFadhxUnYRiyRggQnmBOw4AIIRmKREdNdLIbp8XT7U652u93QTxpp2q7y59kuu8oGZvzfoP2f9evnzxb1+VWuirmqt08+fP0CAG8/La+BxTJX3Q/YrN69xHcAaCpd1OdXNdf3uRqBE/wEcAkAzHQH1E9zVX1GpzfA5n7XjCJBYZFE5RZKAGcrdwQChhpdHUYgwDe6bXJiyKJI+R0KmwFtcmLI4oC8HYXNAAGafqexE4UaQQ8S28fpEZAYMwHuLJ+xsuVJ0siRHle7VEKi4SHAt9hseYc0aqWR1WL7kUJCojHIEmAAZPSZiY2cstAlgFo/oHvGcKUbaeySdZ5XbBWE4GqUvNyuC+qf3cffMbI+EAA2BImFk4UPfWI+TmNDxtOYbD64FxrSfLIR+uVsg319JKV+OQT0tY9K/X4ExB4VCkQ/AmKPCqmRgORyloAGCUguh4BQPMN10paerh35vQjQzUCHViie4drupIdMR34vAnQzcMTjsIV791E4oKgMwbnLy1GOhfsuAbap6J1+UrZM3ZCMpGfUapfGl0hiBPetoNa3TcbxTe00yTIxfQeN/g6NL8BVvf17XaVE3NpmYG18rD2iqasGttW2V30z/iE01mL5/sc1gDupAqPldkeCgXX15vIFANQfz76B6EJZVDSI+ZZePXwGzOtxomXFHLyi1pkaSyOOPugCCNedDHR4i+DeBYQ70dThJiByJ3JDGkIfBxmcIXe4vASolgDR4edSsanvDWdBE8ATFPUMEjvyJAaSA2XnRjnxgJEgJiDW5dG5JvkhJkDqIIb+l4Z5CYzdgLExE6DW1Fi2Aq2hnoCgZbP01qUzIjGyk6DqpUsrZOULoo64TcicoZj3Aa6ydO8Y7dA+KBWFxacA7XsCUVg8BgUatVgMdzs8EUxzCSSEPiQWuBqbyupQxQMk+VNZHaolMJXRlUBFgDm6Uw8e9zaCyYLHQyHAftcGhIaLLTK2HrYvi32Xx0MiUJ/sqWwKmTGngYf8hoDN71+r00ePbzI1CRVzc0VNzLfmdVVytDu+OFkNVteMieEPKW7FehhZa2YAAAAASUVORK5CYII="
        />
        {{ TranslationKeys.AuthMsSignin | translate }}
      </button>
    </div>
  </div>
  <div id="meta">
    <div class="details">
      <span class="header">{{ TranslationKeys.AuthConnected | translate }}: </span>
      <span class="value">{{ environmentName }}</span>
    </div>

    <div class="details">
      <span class="header"> {{ TranslationKeys.AuthVersion | translate }}: </span><span class="meta-value">{{ appVersion }}</span>
    </div>

    <div class="details">
      <span class="header"> {{ TranslationKeys.AuthPowered | translate }}:</span> <span class="meta-value">LUWARE.COM</span>
    </div>
  </div>
</div>
